export default "__VITE_ASSET__CIFPQdXl__"